import { render, staticRenderFns } from "./RequirementGroup.vue?vue&type=template&id=3c7c84b7"
import script from "./RequirementGroup.vue?vue&type=script&lang=js"
export * from "./RequirementGroup.vue?vue&type=script&lang=js"
import style0 from "./RequirementGroup.vue?vue&type=style&index=0&id=3c7c84b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports